// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3w0au","buttons":"RemoveExpirationActionButtons_buttons__7IUSj"};